import React from 'react';
import { esImagenValida } from '../utils/logo';

// El encabezado de los papeles: logo, empresa y a la derecha qué papel es.
//
// Vive aparte porque lo usan los TRES —relación, comprobante y remisión— y
// tres encabezados escritos por separado es como terminan diciendo el NIT de
// tres formas distintas. Cambiando aquí, cambian los tres.
//
// El logo se pinta solo si de verdad es una imagen. Lo guardado se valida al
// entrar y al salir, pero un papel firmado no es sitio para confiar en que la
// validación de hace un mes se hizo bien.
function Membrete({ v, titulo, cual }) {
  return (
    <div className="cbz">
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', minWidth: 0 }}>
        {esImagenValida(v.logo) && (
          <img src={v.logo} alt=""
               style={{ width: 54, height: 54, objectFit: 'contain', flexShrink: 0 }} />
        )}
        <div style={{ minWidth: 0 }}>
          <div className="neg">{v.negocio || titulo}</div>
          {v.nit && <div className="chico">NIT {v.nit}</div>}
          {(v.direccion || v.ciudad) && (
            <div className="chico">
              {[v.direccion, v.ciudad].filter(Boolean).join(' · ')}
            </div>
          )}
          {v.telefono && <div className="chico">Tel. {v.telefono}</div>}
        </div>
      </div>
      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <div className="neg">{titulo}</div>
        <div className="chico">
          {v.numero ? 'No. ' + v.numero + ' · ' : ''}{cual}
        </div>
      </div>
    </div>
  );
}

export default Membrete;
